import firebase from 'firebase';

const config = {
    apiKey: "AIzaSyBhUOPxkHgMZ0nMkOvBAH30YGAfgGx3Bvg",
    authDomain: "chirosystem.firebaseapp.com",
    databaseURL: "https://chirosystem.firebaseio.com",
    projectId: "chirosystem",
    storageBucket: "chirosystem.appspot.com",
    messagingSenderId: "1075657481179"
  };

  const firebaseRef = firebase.initializeApp(config);
  export { firebaseRef }



// WEBPACK FOOTER //
// ./src/routes/firebase.js